import { Box, Typography, Button } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Gavel as GavelIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

function StepConclusaoJurado({ idioma }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleIrParaPainel = () => {
    if (idioma) {
      const lang = idioma.split('-')[0].toLowerCase();
      i18next.changeLanguage(lang);
    }
    navigate('/jurado');
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" py={4} gap={2}>
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'success.main',
          bgcolor: 'rgba(46, 125, 50, 0.1)',
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 48 }} />
      </Box>
      <Typography variant="h5">{t('wizard.jurado.step3.title')}</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
        {t('wizard.jurado.step3.subtitle')}
      </Typography>
      <Button
        variant="contained"
        size="large"
        startIcon={<GavelIcon />}
        sx={{ mt: 2, minWidth: 220 }}
        onClick={handleIrParaPainel}
      >
        {t('wizard.jurado.step3.irpainel')}
      </Button>
    </Box>
  );
}

export default StepConclusaoJurado;
